import green_light from '@/assets/img/mainbanner/green_light.png'
import insurance_img from '@/assets/img/mainbanner/insurance_mp4.gif'
import green_light_img from '@/assets/img/mainbanner/main3_third.gif'
import mobile_carimg from '@/assets/img/mainbanner/mo_main_service_car.gif'
import mo_red_light_img from '@/assets/img/mainbanner/mo_main3_first.gif'
import mo_yellow_light_img from '@/assets/img/mainbanner/mo_main3_second.gif'
import pc_carimg from '@/assets/img/mainbanner/pc_main_service_car.gif'
import pc_red_light_img from '@/assets/img/mainbanner/pc_main3_first.gif'
import pc_yellow_light_img from '@/assets/img/mainbanner/pc_main3_second.gif'
import red_light from '@/assets/img/mainbanner/red_light.png'
import warning_icon from '@/assets/img/mainbanner/warning_icon.png'
import yellow_light from '@/assets/img/mainbanner/yellow_light.png'
import { Main3Desc } from '@/styles/Web/Main/main3desc_styled'
import { MainLayout } from '@/styles/Web/Main/styled'

const Main3DescSection = () => {
  return (
    <>
      <MainLayout>
        {/* MainService1Section */}
        <Main3Desc>
          <p className="section_title">우리나라에만 있는 독특한 주차문화</p>
          <div className="section_desc service1_pc">
            이제 주차 연락 시
            <br />
            <span className="underline">전화번호 노출</span> 걱정 끝!
          </div>
          <div className="section_desc service1_mo">
            이제 주차 연락 시
            <br />
            <span className="underline">전화번호 노출</span> <br />
            걱정 끝!
          </div>
          <img className="pc-car" src={pc_carimg} alt="car_img" />
          <img className="mobile-car" src={mobile_carimg} alt="car_img" />
        </Main3Desc>

        {/* MainService2Section */}
        <Main3Desc>
          <div className="main-service_content service2">
            <section>
              <div className="section_desc service2">
                <div>
                  <img className="color_light" src={red_light} alt="red_light" />
                  <p>
                    내 개인정보에 <br />
                    <span className="underline">빨간불</span>이 켜졌다?
                  </p>
                </div>
              </div>
              <div>
                <span>365일 24시간 노출되고 있는 개인전화번호</span>
                <p>
                  매너로 생각하고 차량 위에 올려둔 내 개인전화번호 <br />
                  보이스피싱, 불법광고, 스토킹 등 범죄에 악용될 수 있습니다.
                </p>
              </div>
            </section>
            <section>
              <img className="pc" src={pc_red_light_img} alt="red_light_img" />
              <img className="mo" src={mo_red_light_img} alt="red_light_img" />
            </section>
          </div>
        </Main3Desc>

        {/* MainService3Section */}
        <Main3Desc>
          <div className="main-service_content service3">
            <div className="mobile_waring">
              <img src={warning_icon} alt="" />
              <p>
                <span>를 확인해 주세요!</span>
                <p>
                  호출하려는 차량이 오토콜에 <br />
                  가입되어 있지 않으면 이용이 어렵습니다.
                </p>
              </p>
            </div>
            <section>
              <img className="pc" src={pc_yellow_light_img} alt="car imoticon" />
              <img className="mo" src={mo_yellow_light_img} alt="car imoticon" />
            </section>
            <section>
              <div className="section_desc service3">
                <div>
                  <img className="color_light" src={yellow_light} alt="yellow_light_img" />
                  <p>
                    <span className="underline">직접 통화 없이</span>
                    <br />
                    운전자를 호출하세요.
                  </p>
                </div>
              </div>
              <div>
                <span>&ldquo;차 빼달라고 전화했는데 왜 짜증을 내세요...&rdquo;</span>
                <p className="ser3_pc_text">
                  불편할 수 있는 직접적인 상대방과 전화통화 없이
                  <br />
                  버튼만 누르면 운전자를 호출할 수 있습니다.
                </p>
              </div>
              <div className="warning_message">
                <img src={warning_icon} alt="" />
                <p>
                  <span>를 확인해 주세요!</span>
                  <br />
                  호출하려는 차량이 오토콜에 가입되어 있지 않으면 이용이 어렵습니다.
                </p>
              </div>
            </section>
          </div>
        </Main3Desc>

        {/* MainService4Section */}
        <Main3Desc>
          <div className="main-service_content service4">
            <section>
              <div className="section_desc service4">
                <div>
                  <img className="color_light" src={green_light} alt="red_light" />
                  <p>
                    <span className="underline">보이는 ARS</span>로
                    <br />
                    간편하게 운전자 호출!
                  </p>
                </div>
              </div>
              <div>
                <span>전화걸고, 화면보호, 버튼 누르면 호출 완료!</span>
                <p>
                  ARS, 다시 들을 필요 없이 직접 화면을 보고 <br />
                  운전자를 호출 할 수 있는 방법을 선택해보세요.
                </p>
              </div>
            </section>
            <section>
              <img src={green_light_img} alt="red_light_img" />
            </section>
          </div>
        </Main3Desc>

        {/* MainInsuranceSection */}
        <Main3Desc>
          <div className="main-service_content_insurance serviceInsurance">
            <section>
              <div className="section_desc_insurance serviceInsurance">
                <div className="pc-insurance-main-text">
                  <p>
                    혹시라도
                    <br />
                    <span className="underline">피싱 피해</span>가 발생한다면?
                  </p>
                </div>
                <div className="mo-insurance-main-text">
                  <p>
                    혹시라도 <span className="underline">피싱 피해</span>가<br />
                    발생한다면?
                  </p>
                </div>
              </div>
              <div className="pc-insurance-sub-text">
                <p>오토콜 이용 중 피싱 피해가 발생하면 보상 혜택을 제공합니다.</p>
                <span>
                  본 서비스 이용 중 피싱 사기 피해(보이스피싱, 스미싱 등)가 발생한 경우,
                  <br />
                  사고 입증 자료(경찰신고서 등)를 제출 하시면 가입자 1인 1사고 당<br />
                  보험한도액 70만 원 내 보상받을 수 있습니다.
                  <br />
                  <br />
                  *자기부담금 별도(14만 원), 증권상 최대 보상한도액 초과 시 지급 불가
                </span>
              </div>
              <div className="mo-insurance-sub-text">
                <p>오토콜 이용 중 피싱 피해가 발생하면 보상 혜택을 제공합니다.</p>
                <span>
                  본 서비스 이용 중 피싱 사기 피해(보이스피싱, 스미싱 등)가 발생한 경우, 사고 입증
                  자료(경찰신고서 등)를 제출 하시면 가입자 1인 1사고 당 보험한도액 70만 원 내
                  보상받을 수 있습니다.
                  <br />
                  <br />
                  *자기부담금 별도(14만 원), 증권상 최대 보상한도
                  <br />액 초과 시 지급 불가
                </span>
              </div>
            </section>
            <section>
              <img src={insurance_img} alt="insurance banner mp4" />
            </section>
          </div>
        </Main3Desc>
      </MainLayout>
    </>
  )
}
export default Main3DescSection
